import React from "react";
import { HelpCircle } from "lucide-react";

/**
 * Botão fixo "?" pra reabrir manualmente o tour guiado da tela atual --
 * usado em conjunto com useProductTour (chame `start()` do hook no onClick).
 * Sempre visível, independente do usuário já ter visto o tour ou pulado.
 */
export default function TourRestartButton({ onClick, label = "Rever tour desta tela" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      aria-label={label}
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-11 h-11 rounded-full bg-slate-900 border border-slate-700 text-[#25D366] shadow-lg hover:bg-slate-800 hover:border-[#25D366] transition-colors"
      data-testid="tour-restart-button"
    >
      <HelpCircle className="w-5 h-5" />
    </button>
  );
}
